var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDocument = function SvgDocument(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none",
    viewBox: "0 0 20 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0875C4",
    fillRule: "evenodd",
    d: "m12.258 2.408 4.167 4.167a.86.86 0 0 1 .241.591v9.167c0 1.375-1.125 2.5-2.5 2.5H5.833a2.507 2.507 0 0 1-2.5-2.5V4.667c0-1.375 1.125-2.5 2.5-2.5h5.833c.225 0 .434.083.592.241m-.592 4.759h2.992l-2.992-2.992zM5 16.333c0 .459.375.834.833.834h8.333a.836.836 0 0 0 .834-.834v-7.5h-5v-5H5.833A.836.836 0 0 0 5 4.666zm1.666-.833v-1.667h6.667V15.5zm0-5v1.666h6.667V10.5zm0-3.333h2.5v1.666h-2.5z",
    clipRule: "evenodd"
  })));
};
export { SvgDocument as Icon };
export default __webpack_public_path__ + "static/media/c94bca791ebea74251936969a2a85ea9.svg";